import type { LeaderboardRow } from "../api/types";
import { money, money2 } from "../lib/format";

// Show ~10 rows, then scroll the rest inside the card (keeps the section compact
// even with a long pledger wall). Mobile rows are taller (two lines), so the cap
// is a little larger there.
const VISIBLE_ROWS = 10;

export function Leaderboard({ rows, isDesktop }: { rows: LeaderboardRow[]; isDesktop: boolean }) {
  const rowHeight = isDesktop ? 47 : 61; // approximate rendered row height in px
  const listMaxHeight = VISIBLE_ROWS * rowHeight;
  return (
    <div style={{ background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 16, overflow: "hidden" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isDesktop ? "40px 1.4fr 1fr 1fr" : "32px 1fr auto",
          gap: 12,
          padding: "12px 18px",
          fontSize: 11,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.6,
          color: "var(--ink-soft)",
          background: "var(--bg)",
          borderBottom: "1px solid var(--line)",
        }}
      >
        <div>#</div>
        <div>Name</div>
        {isDesktop && <div>Pledge</div>}
        <div style={{ textAlign: "right" }}>Total Amount</div>
      </div>
      <div style={{ maxHeight: listMaxHeight, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
        {rows.map((p, i) => (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: isDesktop ? "40px 1.4fr 1fr 1fr" : "32px 1fr auto",
              gap: 12,
              padding: "14px 18px",
              alignItems: "center",
              fontSize: 14,
              color: "var(--ink)",
              borderBottom: i === rows.length - 1 ? "none" : "1px solid var(--line)",
            }}
          >
            <div
              style={{
                fontFamily: "var(--display)",
                fontVariantNumeric: "tabular-nums",
                color: i < 3 ? "var(--accent)" : "var(--ink-soft)",
                fontWeight: 500,
                fontSize: 16,
              }}
            >
              {i + 1}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {p.first} {p.last}
              </div>
              {!isDesktop && (
                <div style={{ fontSize: 11, color: "var(--ink-soft)" }}>
                  {money2(p.rate)}/mi{p.cap ? ` · cap ${money(p.cap)}` : ""}
                </div>
              )}
            </div>
            {isDesktop && (
              <div style={{ color: "var(--ink-soft)", fontVariantNumeric: "tabular-nums" }}>
                {money2(p.rate)}/mi{p.cap ? ` · cap ${money(p.cap)}` : ""}
              </div>
            )}
            <div style={{ textAlign: "right", fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>{money(p.owed)}</div>
          </div>
        ))}
        {rows.length === 0 && (
          <div style={{ padding: 28, textAlign: "center", color: "var(--ink-soft)", fontSize: 14 }}>
            No pledgers yet. Be the first.
          </div>
        )}
      </div>
    </div>
  );
}
